"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoSimulationMock = void 0;

var _Simulation = require("../entities/Simulation");

var autoSimulationMock = [new _Simulation.Simulation({
  interestRateMonthly: 1.15,
  installmentsQuantity: 12,
  installmentsAmount: 1234.23
}), new _Simulation.Simulation({
  interestRateMonthly: 1.25,
  installmentsQuantity: 24,
  installmentsAmount: 734.15
}), new _Simulation.Simulation({
  interestRateMonthly: 1.55,
  installmentsQuantity: 36,
  installmentsAmount: 434.04
})];
exports.autoSimulationMock = autoSimulationMock;